var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({class:{ logo: true },attrs:{"alt":"logo","src":require("@/assets/image/logo_network.svg"),"height":_vm.height,"width":`${_vm.simple ? _vm.height : 'auto'}`}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }